import React, {SetStateAction, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {productApi} from '../../../../api';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import ConfirmDeleteModal from '../../../../components/modal/ConfirmDeleteModal';
import {EmptyState} from '../../../../components/shared/EmptyState';
import {IBrand} from '../../brands/interfaces/IBrand';
import {IProduct} from '../interfaces/IProduct';

interface IProductTableProps {
  productList: IProduct[];
  setProductList: React.Dispatch<SetStateAction<IProduct[]>>;
}

const ProductTable = ({productList, setProductList}: IProductTableProps) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState<IProduct>();
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);

  const deleteProductHandler = async () => {
    if (selectedProduct?.id) {
      const {
        data: {data},
      } = await productApi.deleteProduct(selectedProduct?.id);
      setProductList(data);
    }
  };
  return (
    <div className="table-responsive">
      {!!productList?.length ? (
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">{t('general.id')}</th>
              <th scope="col">{t('general.fullName')}</th>
              <th scope="col">{t('general.brand')}</th>
              <th scope="col" className="text-end">
                {t('general.actions')}
              </th>
            </tr>
          </thead>
          <tbody>
            {productList?.map((product) => {
              const {id, name, brand} = product;
              return (
                <tr key={id}>
                  <th>{id}</th>
                  <td>{name}</td>
                  <td>{(brand as unknown as IBrand)?.name ?? '-'}</td>
                  <td className="d-flex justify-content-end">
                    <Button
                      color="warning"
                      size="sm"
                      onClick={() => {
                        navigate(`/app/management/products/update/${id}`);
                      }}
                    >
                      <Icon name="edit" />
                      {t('general.edit')}
                    </Button>
                    <Button
                      color="danger"
                      size="sm"
                      className="ms-1"
                      onClick={() => {
                        setIsDeleteModalOpened(true);
                        setSelectedProduct(product);
                      }}
                    >
                      <Icon name="trash" />
                      {t('general.delete')}
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <EmptyState />
      )}
      <ConfirmDeleteModal
        show={isDeleteModalOpened}
        setShow={setIsDeleteModalOpened}
        itemId={selectedProduct?.id as number}
        itemName={selectedProduct?.name as string}
        deleteHandler={deleteProductHandler}
      />
    </div>
  );
};

export default ProductTable;
